// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createLinkIconStyles } from "@conklin/XDL/Utilities";
import { currentBillingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentBillingAddress";
import Edit from "@insite/mobius/Icons/Edit";
import { css } from "styled-components";

currentBillingAddressStyles.gridContainer = {
    gap: 0,
};

currentBillingAddressStyles.addressFormModal = {
    sizeVariant: "medium",
};

currentBillingAddressStyles.headingGridItem = {
    width: 12,
};

currentBillingAddressStyles.editLink = {
    ...createLinkIconStyles(Edit, "small", "left", false, {
        css: css`
            margin-left: 30px;
            margin-top: 3px;
            white-space: nowrap;
        `,
    }),
};
